import { BaseYMapV2 } from "../../modules/ymap/index.js";

function waitForMapMethod(map, methodName, callback) {
    const timer = setInterval(() => {
        if (typeof map[methodName] === "function") {
            clearInterval(timer);
            callback();
        }
    }, 50);
}

export function initContactsMap() {
    const mapContainer = document.querySelector("#contacts__map");

    if (!mapContainer) return;

    const map = new BaseYMapV2(mapContainer, {
        center: [55.646685, 37.62616],
        zoom: 14,
    });

    waitForMapMethod(map, "addMark", () => {
        map.setCenter([55.646685, 37.62616], 14);

        const placemark = map.addMark([55.646685, 37.62616], {
            name: "Адрес",
            description: "1-ый Варшавский проезд, дом 2, стр. 8, офис 411",
        });

        placemark.balloon.open();
    });
}